<template>
  <div class="organization-name-hint">
    Поиск по УНП происходит только по полному соответствию, внимательно
    проверяйте вводимое значение.
  </div>
</template>

<script>
export default {
  name: "OrganizationNameHint",
};
</script>

<style scoped lang="less">
.organization-name-hint {
  width: 420px;
}
</style>
